import { lazyImport } from '@/utils/lazyImport';

const { AuthRoutes } = lazyImport(() => import('@/features/auth'), 'AuthRoutes');
const { DevicesRoutes } = lazyImport(() => import('@/features/devices'), 'DevicesRoutes');

export const publicRoutes = [
  {
    path: '/auth/*',
    element: <AuthRoutes />,
  },
  { path: '/devices/*', element: <DevicesRoutes />, children: [] },
];
